import { render } from "./MainSearchResultModal.vue?vue&type=template&id=0c644086"
import script from "./MainSearchResultModal.vue?vue&type=script&lang=js"
export * from "./MainSearchResultModal.vue?vue&type=script&lang=js"

import "./MainSearchResultModal.vue?vue&type=style&index=0&id=0c644086&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__